import {Component, OnInit} from '@angular/core';
import {FooterComponent} from '../footer/footer.component';
import {ToolbarComponent} from '../toolbar/toolbar.component';

@Component({
    selector: 'frog-privacy',
    templateUrl: './privacy.component.html',
    styleUrls: ['./privacy.component.scss'],
    imports: [ToolbarComponent, FooterComponent],
})
export class PrivacyComponent implements OnInit {
    constructor() {}

    ngOnInit(): void {}
}
